import { isIOSDevice } from '@golden/app-plugins'
import type { Event as SentryEvent } from '@golden/sentry-vue'

const STACK_OVERFLOW_PATTERN = /^Maximum call stack size exceeded\.?$/
const CHROME_IOS_PATTERN = /\bCriOS\//
const NON_PAGE_SEGMENTS = ['assets', 'src', 'node_modules']

export const isPageScriptStackOverflow = (event: SentryEvent, origin: string) => {
  try {
    const values = event.exception?.values
    // values.length > 1 時表示可能 exception 中還有其他錯誤，丟棄可能導致錯過資訊
    if (!Array.isArray(values) || values.length !== 1) return false
    const [exception] = values
    if (exception.type !== 'RangeError' || !STACK_OVERFLOW_PATTERN.test(exception.value ?? '')) return false
    if (!CHROME_IOS_PATTERN.test(navigator.userAgent) || !isIOSDevice()) return false
    const frames = exception.stacktrace?.frames
    if (!Array.isArray(frames) || frames.length === 0) return false
    for (const frame of frames) {
      const url = new URL(frame.filename ?? '')
      const segments = url.pathname.split('/')
      const isPageSource =
        url.origin === origin &&
        !segments.some((segment) => NON_PAGE_SEGMENTS.includes(segment)) &&
        !segments[segments.length - 1].includes('.')
      if (!isPageSource) return false
    }
    return true
  } catch {
    return false
  }
}
